const CountStroke1 = () => {
	return (
		<svg
			className='svg-max'
			preserveAspectRatio='none'
			viewBox='-27.1 45 54.8 54.1'>
			<path d='M-9.5,98.4c0,0-27.2-28.8-11.3-45.4s50.3-0.8,46.8,22.9S-0.1,89.5-7.7,85.8' />
		</svg>
	);
};

const CountStroke2 = () => {
	return (
		<svg
			className='svg-max'
			preserveAspectRatio='none'
			viewBox='-29 45.6 51.9 54.9'>
			<path d='M-20.1,55c0,0,23-18.1,37.3,0s-6.2,50-29.1,43.2c-22.9-6.8-15.7-25.2-11-32.1' />
		</svg>
	);
};

const CountStroke3 = () => {
	return (
		<svg
			className='svg-max'
			preserveAspectRatio='none'
			viewBox='-31.5 47.4 57.2 50.9'>
			<path d='M0.2,97.2c0,0-33.6-4.9-30.1-27.6S10.9,40,21.6,61.4S11.7,89.3,3.4,90.6' />
		</svg>
	);
};

const CountStroke4 = () => {
	return (
		<svg
			className='svg-max'
			preserveAspectRatio='none'
			viewBox='-23.2 46.6 55.1 51.1'>
			<path d='M18.8,93.5c0,0-32,11.5-39.5-10.2S1.4,38.1,20.9,51.9s4.4,29.2-2.4,34.3' />
		</svg>
	);
};

const CountStroke5 = () => {
	return (
		<svg
			className='svg-max'
			preserveAspectRatio='none'
			viewBox='-23.2 47 53.2 53.1'>
			<path d='M22.7,56.1c0,0,15.8,30.1-4.6,40.6s-47.9-15.6-36.9-36.9s28.3-8.4,34.3-2.4' />
		</svg>
	);
};

export { CountStroke1, CountStroke2, CountStroke3, CountStroke4, CountStroke5 };
